/*
 * @Description: 通用正则
 * @Author: maxiangrui
 * @Date: 2021-04-27 09:59:43
 * @LastEditors: maxiangrui
 * @LastEditTime: 2021-06-07 16:03:53
 */

export default {
  // element 时间选择器
  pickerTimeSet: [
    {
      text: "今天",
      onClick(picker) {
        const end = new Date();
        const start = new Date(new Date().setHours(0, 0, 0, 0));
        // start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "昨天",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        start.setHours(0, 0, 0, 0);

        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        end.setHours(23, 59, 59, 999);

        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "过去7天",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        start.setHours(0, 0, 0, 0);

        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        end.setHours(23, 59, 59, 999);
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "过去14天",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
        start.setHours(0, 0, 0, 0);
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        end.setHours(23, 59, 59, 999);
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "过去30天",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        start.setHours(0, 0, 0, 0);
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        end.setHours(23, 59, 59, 999);
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "本周",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        let day = end.getDay(); //获取当前星期X(0-6,0代表星期天)
        if (end.getDay() == 0) {
          day = 7;
        }
        start.setTime(start.getTime() - 3600 * 1000 * 24 * (day - 1));
        start.setHours(0, 0, 0, 0);
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "上周",
      onClick(picker) {
        const end = new Date();
        const start = new Date();

        let day = end.getDay(); //获取当前星期X(0-6,0代表星期天)
        if (end.getDay() == 0) {
          day = 7;
        }
        //获得上周的结束时间
        end.setTime(end.getTime() - 3600 * 1000 * 24 * day);
        end.setHours(23, 59, 59, 999);

        //获得上周的开始时间
        start.setTime(end.getTime() - 3600 * 1000 * 24 * 6);
        start.setHours(0, 0, 0, 0);
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "本月",
      onClick(picker) {
        const end = new Date();
        const start = new Date();

        //let month = start.getMonth()+1    //getMonth()是以0开始的月份
        let day = start.getDate(); //获取当前日(1-31)

        start.setTime(start.getTime() - 3600 * 1000 * 24 * (day - 1));
        start.setHours(0, 0, 0, 0);
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "上个月",
      onClick(picker) {
        const end = new Date();
        const start = new Date();

        let day = end.getDate(); //获取当前日(1-31)

        //获得上个月的结束时间
        end.setTime(end.getTime() - 3600 * 1000 * 24 * day);
        end.setHours(23, 59, 59, 999);

        //获得上个月的开始时间
        let endday = end.getDate(); //获取当前日(1-31)
        start.setTime(end.getTime() - 3600 * 1000 * 24 * (endday - 1));
        start.setHours(0, 0, 0, 0);

        picker.$emit("pick", [start, end]);
      },
    },
  ],



  //六种订单状态Options数组
  orderStOptions: [
    {
      label: "待确认",
      value: 1,
    },
    {
      label: "待发货",
      value: 2,
    },
    {
      label: "配货中",
      value: 3,
    },
    {
      label: "待收货",
      value: 4,
    },
    {
      label: "已完成",
      value: 5,
    },
    {
      label: "已退货",
      value: 6,
    },
  ],
  //审核单状态状态Options数组[0 作废单 1未审核 2 有效单 3 暂存单]
  invalIndOptions: [
    {
      label: "作废单",
      value: 0,
    },
    {
      label: "未审核",
      value: 1,
    },
    {
      label: "有效单",
      value: 2,
    },
    {
      label: "暂存单",
      value: 3,
    }
  ],
  //复审订单[0 电话重复 1 IP重复 2 黑名单]
  reviewOrders: [
    {
      label: "电话重复",
      value: 0,
    },
    {
      label: "IP重复",
      value: 1,
    },
    {
      label: "黑名单",
      value: 2,
    },
  ],
  //黑名单作废订单Options数组[0 作废单 1未审核]
  blkInvalidOrderOptions: [
    {
      label: "手机黑名单",
      value: 0,
    },
    {
      label: "IP黑名单",
      value: 1,
    },
    {
      label: "设备黑名单",
      value: 2,
    }
  ],

  //审核单状态状态Map [0 作废单 1 未审核 2 有效单 3 暂存单]
  invalIndMap: new Map([[0, '作废单'], [1, '未审核'], [2, '有效单'],[3, '暂存单']])

}



// WEBPACK FOOTER //
// ./src/utils/mallConst.js